<template>
  <v-app>

  </v-app>
</template>

<script>

import axios from 'axios';
import config from '@/../config.js'
import App from '@/models/instance/App'
import Member from '@/models/instance/Member'

export default {
  mounted : function () {
    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.line.queue.tracking_queue
        ,{ app_id: App.getAppId() , qrcode:this.$route.params.qrcode}
        ,{ headers: Member.getTokenHeader()})
    .then(response => {
        this.$store.commit('finishLoading',que)
        if(response.data.isSuccess){
            this.$router.push({name:"Success",params: { 
                success_text_1:  this.$t('success_queuetracking_1')
                ,success_text_2:  this.$t('success_queuetracking_2')
            }})
        }
    })     
  }
}
</script>